import React from 'react';
import styles from "../styles/standings-widget.module.scss";
import classNames from "classnames";
import {EntityDescriptionModuleAsync} from "../../../modules/entity-description-module/components/entity-description.module.async";
import {ENTITY_DESCRIPTION} from "../../../modules/entity-description-module/entity-description.module.consts";

export const StandingsWidgetEntityDescription = ({controller, isCollapsed, isPreviewStandings}) => {
  const {state} = controller;
  const {
    competition,
    entityDescriptionId,
    entityDescriptionType,
    isWidget,
    sportTypeId,
    shouldRenderEntityDescription
  } = state;

  const isVisible: Boolean = shouldRenderEntityDescription && !isPreviewStandings && !isCollapsed && !isWidget && entityDescriptionId;

  const entityDescriptionProps = {
    entityId: entityDescriptionId,
    entityType: entityDescriptionType,
    sectionsName: competition?.hasStandingsGroups ? [ENTITY_DESCRIPTION.SECTION_NAME.groups] : [ENTITY_DESCRIPTION.SECTION_NAME.standings],
    sportTypeId
  }

  return isVisible ? <div className={classNames(styles.entity_description)}>
    <EntityDescriptionModuleAsync {...entityDescriptionProps}/>
  </div> : null
};
